import React        from 'react';
import PropTypes    from 'prop-types';

import CheckboxAtm  from "../../atomic/Checkbox/Checkbox";
import ColAtm       from "../../atomic/Col/Col";
import BlockAtm from "../../atomic/Block/Block";


const PhotoSelect = props => (
    <div className={props.colClassname}
         htmlFor={props.htmlFor}
         ref={props.innerRef}
         style={props.style}>
        <BlockAtm className={props.blockClass} onClick={props.onClick} htmlFor={props.htmlFor}>
            <CheckboxAtm
                name={props.name}
                id={props.id}
                className={props.className}
                onChange={props.onChange}
                checkboxId={props.checkboxId}
                value={props.value}
                labelPlacement={props.labelPlacement}
                checked={props.checked}
                defaultChecked={props.defaultChecked}
            />
            {
                // Sürükleme yalnızca bu tutamaçtan yapılır; tutamaçta touch-action:none olduğu
                // için mobilde sürükleme scroll ile çakışmaz, fotoğrafın gövdesi scroll/tap için serbest kalır.
                props.showDragHandle &&
                <div className="photo-drag-handle" {...props.dragHandleProps}>
                    <i className="fas fa-arrows" />
                </div>
            }
            <ColAtm htmlFor={props.htmlFor}>
                <ColAtm htmlFor={props.htmlFor}>
                    <ColAtm className="channel-logo" htmlFor={props.htmlFor}>
                        <label htmlFor={props.htmlFor}>
                            <i className="fas fa-check" />
                            <img src={props.src} htmlFor={props.htmlFor} alt={props.name} draggable={props.draggable} />
                        </label>
                    </ColAtm>
                </ColAtm>
            </ColAtm>
        </BlockAtm>
    </div>
);

PhotoSelect.propTypes = {
    id: PropTypes.any,
    name: PropTypes.any,
    src: PropTypes.any,
    className: PropTypes.string,
    iconClass: PropTypes.any,
    value: PropTypes.any,
    htmlFor: PropTypes.any,
    colClassname: PropTypes.string,
    blockClass: PropTypes.string,
    checkboxId: PropTypes.any,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    checked: PropTypes.any,
    defaultChecked: PropTypes.any,
    labelClass: PropTypes.string,
    text: PropTypes.any,
    draggable: PropTypes.bool,
    // Sürükle-bırak sıralaması için (bkz. SortablePhotoSelect); kullanılmazsa DOM aynı kalır
    innerRef: PropTypes.func,
    style: PropTypes.object,
    // Sürükleme tutamacı: attributes + listeners birleşik, sadece sürüklenebilir fotoğrafta gösterilir
    showDragHandle: PropTypes.bool,
    dragHandleProps: PropTypes.object,
};

export default PhotoSelect;
